import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { productDetailsCall, claimCoupon } from "../Services/Service";
import UserContext from "../context/UserContext";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Snackbar from "@mui/material/Snackbar";
import Slide from "@mui/material/Slide";
import Backdrop from "@mui/material/Backdrop";
import Spinner from "./Spinner";
import "react-image-gallery/styles/css/image-gallery.css";
import { BottomSheetCustom } from "@cred/neopop-web/lib/components";
import BottomLogin from "./bottomLogin";
import Confetti from "react-confetti";
import { FaTrophy, FaGift } from "react-icons/fa";
import CountdownTimer from "../components/CountdownTimer";

const CouponProductDetails = () => {
  const [loading, setLoading] = useState(true);
  const [cartMessage, setCarMessage] = useState({});
  const location = useLocation();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [isApplied, setIsApplied] = useState(false);
  const [serviceData, setServiceData] = useState([]);
  const [coupons, setCoupons] = useState([]);
  const [coupon, setCoupon] = useState({});
  const { state } = useContext(UserContext);
  const queryParams = new URLSearchParams(location.search);
  const copId = queryParams.get("couponId");
  const { id } = useParams();
  const [imageSet, setImageSet] = useState([]);
  const [canProceed, setCanProceed] = useState("N");
  const [showRedeem, setShowRedeem] = useState("N");
  const isLoggedIn = localStorage.getItem("auth") ? true : false;
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [show, setShow] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);
  const [expiry, setExpiry] = useState(null);
  const [expiresOn, setExpiresOn] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    setLoading(true);
    productDetailsCall(id, copId).then((res) => {
      setServiceData({
        ...serviceData,
        type: res.data.data[0].type,
        category: res.data.data[0].productTitle,
        description: res.data.data[0].productDesc,
        skuId: res.data.data[0].skuId,
        image: res.data.data[0].productImageArr,
        price: res.data.data[0].productPrice,
        title: res.data.data[0].productTitle,
        id: res.data.id,
        count: res.data.count,
        offerPrice: res.data.data[0].offerPrice,
        discountAmount: res.data.data[0].discountAmount,
        vendorName: res.data.data[0].vendorName,
        variantValue: res.data.data[0].variantValue,
        productStock: res.data.data[0].productStock,
        variantType: res.data.data[0].variantType,
        couponDetails: res.data.couponDetails[0],
      });
      setImageSet(res.data.data[0].productImageArr);
      setCoupons(res.data.coupons);
      setErrorMsg(res.data.errorMessage);
      // Set expiry to 48 hours from now or use expiry from API if available
      setExpiry(
        res.data.data[0].expiry || new Date(Date.now() + 48 * 60 * 60 * 1000)
      );
      setExpiresOn(res.data.couponDetails[0]?.expiresOn);
      if (res.data.showRedeem !== undefined) {
        setShowRedeem(res.data.showRedeem);
      }
      if (res.data.canRedeem !== undefined) {
        setCanProceed(res.data.canRedeem);
      }
      setLoading(false);
    });
  }, [id, copId]);

  const handleRedeem = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const addressId = state?.addressId || "default";
      const firstCouponId = coupons && coupons.length > 0 ? coupons[0] : null;
      const couponIdToUse = firstCouponId ? firstCouponId : copId || 0;
      const response = await claimCoupon(id, addressId, couponIdToUse);
      if (response.data.status === 1) {
        const orderId = response.data.order_id;
        setShowConfetti(true);
        setTimeout(() => setShowConfetti(false), 4000);
        if (orderId) {
          setTimeout(() => nav(`/track?order_id=${orderId}`), 1000);
          return;
        }
        setOpen(true);
        setCarMessage({
          msg:
            response.data.message ||
            response.data.msg ||
            "Coupon claimed successfully!",
          status: response.data.status || 1,
        });
      } else {
        setOpen(true);
        setCarMessage({
          msg: response.data.message || response.data.msg,
          status: response.data.status,
        });
      }

      setTimeout(() => {
        setOpen(false);
      }, 2000);
    } catch (error) {
      setOpen(true);
      setCarMessage({ msg: "Failed to claim coupon", status: 0 });
      setTimeout(() => {
        setOpen(false);
      }, 2000);
    } finally {
      setLoading(false);
    }
  };

  const newArray = imageSet?.map((i) => ({
    original: i.image,
    thumbnail: i.image,
  }));
  const currentPath = window.location.pathname;

  // console.log(expiresOn, serviceData);
  console.log(errorMsg, "isLoggedIn");
  return (
    <div
      className="  d-flex flex-column align-items-center justify-content-center  p-4 mt-4 mb-5 coupon-bg-gradient"
      style={{ height: "100vh" }}
    >
      {showConfetti && (
        <Confetti
          width={window.innerWidth}
          height={window.innerHeight}
          numberOfPieces={300}
          recycle={false}
        />
      )}
      <HelmetProvider>
        <Helmet>
          <title> Reward & Achievement</title>
        </Helmet>
      </HelmetProvider>
      <div className="coupon-card-main shadow-lg rounded-4 p-4 py-4">
        <div className="text-center mb-4">
          <FaGift
            className="animated-gift"
            style={{ color: "#fff", fontSize: 36, marginBottom: 4 }}
          />
          <h2
            className="fw-bold mb-3"
            style={{ fontSize: 25, fontWeight: 600, letterSpacing: 0.5 }}
          >
            Redeem Your Exclusive Coupon!
          </h2>

          <div
            style={{
              backgroundColor: "#212121",
              color: "#fff",
              padding: "4px 12px",
              display: "inline-block",
              borderRadius: 8,
              fontWeight: 600,
              fontSize: 13,
            }}
          >
            Expires in &nbsp;
            <CountdownTimer expiry={expiry} expiresOn={expiresOn} />
          </div>
        </div>

        <div
          className="coupon-card-inner rounded-4 p-2 mb-3 mx-auto"
          style={{
            background: "#fff",
            maxWidth: 230,
          }}
        >
          <div className="text-center">
            <div
              style={{
                color: "#444",
                fontWeight: 700,
                fontSize: 18,
                textTransform: "uppercase",
              }}
            >
              Amazon Pay
            </div>
            <div
              style={{
                color: "#000",
                fontWeight: 800,
                fontSize: 30,
                margin: "0px 0",
              }}
            >
              Gift Card
            </div>
            <FaGift
              style={{ color: "#FFA726", fontSize: 22, marginBottom: 6 }}
            />
            <div style={{ color: "#888", fontSize: 13 }}>
              Issued by <strong>QwikSilver</strong>
            </div>
          </div>
        </div>

        {/* Price Section */}
        <div
          className="text-center mb-4 px-3 py-2 price-card"
          style={{
            // backgroundColor: "rgba(255, 255, 255, 0.25)",
            borderRadius: 10,
            fontSize: 16,
          }}
        >
          {/* <div style={{ marginBottom: 6 }}>
            <strong style={{ color: "#5D4037" }}>Sold by:</strong>{" "}
            <span style={{ color: "gray" }}>
              {serviceData.vendorName || "—"}
            </span>{" "}
          </div> */}
          <div>
            <strong style={{ color: "#5D4037" }}>Price:</strong>{" "}
            <span style={{ fontWeight: 700, color: "black" }}>0 ₹</span>{" "}
            <span style={{ color: "black", fontWeight: 700 }}>+</span>{" "}
            <span style={{ fontWeight: 700, color: "black" }}>
              {serviceData.discountAmount || 0}{" "}
              <img
                src="/assets/images/spicegold.png"
                alt="SG"
                style={{
                  height: 20,
                  width: 20,
                  verticalAlign: "middle",
                  marginLeft: 4,
                }}
              />
            </span>
          </div>
        </div>

        {isLoggedIn ? (
          <button
            disabled={canProceed !== "Y" || loading}
            onClick={handleRedeem}
            type="button"
            className="btnPrimary"
          >
            <FaGift style={{ marginRight: 10, fontSize: 20 }} />
            Get ₹{serviceData.price} Amazon voucher
          </button>
        ) : (
          <button
            // disabled={canProceed !== "Y" || loading}
            onClick={() => setShowLoginModal(true)}
            type="button"
            className="btnPrimary"
          >
            Please Login to Continue
          </button>
        )}

        {errorMsg && serviceData?.couponDetails?.status === "free" ? (
          <div
            className="text-danger text-center mt-3"
            style={{ fontWeight: 500, fontSize: 14 }}
          >
            * {errorMsg}
          </div>
        ) : serviceData?.couponDetails?.status === "used" && isLoggedIn ? (
          <div
            className="text-danger text-center mt-3"
            style={{ fontWeight: 500, fontSize: 14 }}
          >
            * Reward coupon is already redeemed.
          </div>
        ) : canProceed !== "Y" && showRedeem === "Y" && isLoggedIn ? (
          <div
            className="text-danger text-center mt-3"
            style={{ fontWeight: 500, fontSize: 14 }}
          >
            * You need a valid coupon to redeem this reward.
          </div>
        ) : null}
      </div>

      <Backdrop open={loading} style={{ zIndex: "10000" }}>
        <Spinner />
      </Backdrop>
      <BottomSheetCustom
        open={showLoginModal}
        handleClose={() => setShowLoginModal(false)}
        maxHeight="700px"
      >
        <BottomLogin onClose={() => setShowLoginModal(false)} />
      </BottomSheetCustom>
      <Snackbar
        sx={{ height: 300 }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={open}
        TransitionComponent={Slide}
      >
        <Alert
          severity={
            cartMessage.status === 0
              ? "error"
              : cartMessage.status === 1
              ? "success"
              : "error"
          }
        >
          <AlertTitle></AlertTitle>
          {cartMessage.status === 1 ? (
            <span style={{ fontWeight: "bold", color: "#28a745" }}>
              <FaTrophy
                style={{ color: "gold", fontSize: 24, marginRight: 8 }}
              />
              Congratulations! <br />
              {cartMessage.msg} <strong>Enjoy your reward!</strong>
            </span>
          ) : (
            <>{cartMessage.msg}</>
          )}
        </Alert>
      </Snackbar>
      <Snackbar
        sx={{ height: 400 }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={isApplied}
        TransitionComponent={Slide}
      >
        <Alert severity="success">
          <AlertTitle></AlertTitle>
          {coupon.percentage}% Off <strong>coupon applied</strong>
        </Alert>
      </Snackbar>
      <style>{`
           *{ font-family: "Teko", sans-serif;}

         .price-card {
    background: rgba(255, 255, 255);
    // border: 0.54px solid gray;
    border-radius: 5px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); /* Added box shadow */
}
        .coupon-card-main {
        
          margin-bottom: 40px;
        }
        .animated-gift {
          animation: bounceGift 2s infinite cubic-bezier(.68,-0.55,.27,1.55);
          display: inline-block;
        }
        @keyframes bounceGift {
          0%, 100% { transform: translateY(0); }
          25% { transform: translateY(-10px); }
          50% { transform: translateY(-18px) scale(1.08); }
          75% { transform: translateY(-8px); }
        }
      `}</style>
    </div>
  );
};

export default CouponProductDetails;
